<template>
  <filters-form
    v-if="preloaded"

    :initial="initial"

    :items="items"
    :loading="loading"
    :filters="filters"

    :schema="schema"
    :payload="payload"

    :actions="actions"
  />
</template>

<script>
  import { mapState } from 'vuex';

  import namelize from '@sdk/helpers/formatters/namelize';

  import form from '@cordel/helpers/form/mixin';
  import optionsHelper from '@cordel/helpers/form/select/options';

  import FiltersForm from '@sdk/components/Filters/Form.vue';

  // eslint-disable-next-line import/no-extraneous-dependencies
  import preload from '@/helpers/mixins/preload';

  // eslint-disable-next-line import/no-extraneous-dependencies
  import { INITIAL_SIMULATIONS_FILTERS as INITIAL } from '@/store/modules/simulations';

  import payloadGenerator from './payload';
  import schemaGenerator from './schema';

  import {
    SELLER_ID,
    STORE_ID,
    BANK_CODE,
  } from './fields';

  export default {
    name: 'SimulationsListFilters',
    components: {
      FiltersForm,
    },
    mixins: [
      form,
      preload,
    ],
    data() {
      return {
        schema: schemaGenerator(),
        payload: payloadGenerator(),

        initial: {},
        preloaded: false,

        actions: {
          filter: 'simulations/filter',
          clear: 'simulations/clear',
          list: 'simulations/internalList',
        },
      };
    },
    computed: {
      ...mapState([
        'banksWeb',
        'simulations',
        'stores',
        'sellers',
      ]),

      items() {
        return this.simulations.list.items;
      },
      loading() {
        return this.simulations.list.loading;
      },
      filters() {
        return this.simulations.list.filters;
      },
    },
    beforeMount() {
      this.initial = { ...INITIAL };
    },
    mounted() {
      this.getSellers();
      this.getStores();
      this.getBanks();
    },
    methods: {
      getBanks() {
        this.updateLoading(BANK_CODE, true);
        this.preloadBanksWeb(true, { main: true }).then(this.gotBanks);
      },
      gotBanks() {
        this.updateLoading(BANK_CODE, false);
        this.updateOptions(BANK_CODE, optionsHelper(this.banksWeb.list.items, {
          value: 'code',
        }));
      },

      getStores() {
        this.updateLoading(STORE_ID, true);
        this.preloadStores().then(this.gotStores);
      },
      gotStores() {
        const stores = optionsHelper(this.stores.list.items);

        this.updateLoading(STORE_ID, false);
        this.updateOptions(STORE_ID, stores);

        const headerStoreID = this.$route.query.header_store_id;
        let storeID;

        if (headerStoreID) {
          storeID = parseInt(headerStoreID, 10);
        } else if (stores.length > 0 && stores[0].value) {
          storeID = parseInt(stores[0].value, 10);
        } else {
          storeID = undefined;
        }

        this.updateValue(STORE_ID, storeID);
        this.initial.header_store_id = storeID;

        this.preloaded = true;
      },

      getSellers() {
        this.updateLoading(SELLER_ID, true);
        this.preloadSellers().then(this.gotSellers);
      },
      gotSellers() {
        this.updateLoading(SELLER_ID, false);
        this.updateOptions(SELLER_ID, optionsHelper(this.sellers.list.items, {
          prettify: namelize,
        }));
      },
    },
  };
</script>
